// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AdvancedCustomerConfiguration_wrapper__1n46S"};